var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "flat"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 4,
    style: {
      fill: "rgba(100,21,255,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,32a72.869,72.869,0,0,1-1.33,14.07c-.13.67-.28,1.32-.43,1.95C39.26,56.36,35.82,62,32,62c-5.18,0-9.67-10.39-10.75-23.79-.07-.84-.12-1.69-.16-2.55Q21,33.86,21,32a73.316,73.316,0,0,1,1.32-14.07c.63.19,1.26.39,1.91.61A71.947,71.947,0,0,0,23,32c0,1.77.06,3.47.16,5.1q.09,1.29.21,2.52C24.64,52.27,28.91,60,32,60c2.39,0,5.48-4.62,7.35-12.57.15-.63.29-1.29.42-1.97A70.124,70.124,0,0,0,41,32c0-1.77-.06-3.47-.16-5.1q-.09-1.29-.21-2.52C39.36,11.73,35.09,4,32,4H31V2h1c5.18,0,9.67,10.39,10.75,23.79.07.85.12,1.7.16,2.57C42.97,29.56,43,30.77,43,32Z",
    style: {
      fill: "rgba(100,21,255,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,47.122l-.44-1.951.975-.22A65.059,65.059,0,0,0,36.5,37.8,62,62,0,0,0,52.522,25.01c3.272-3.869,4.7-7.319,3.727-9s-4.673-2.174-9.661-1.275A62.019,62.019,0,0,0,27.5,22.212C12.7,30.758,5.917,40.828,7.751,44.006l.5.866-1.732,1-.5-.866c-2.981-5.164,6.4-16.4,20.481-24.527a64.051,64.051,0,0,1,19.734-7.716c6.1-1.1,10.276-.3,11.747,2.243s.074,6.558-3.931,11.295A64.036,64.036,0,0,1,37.5,39.532,67.062,67.062,0,0,1,19.473,46.9Z",
    style: {
      fill: "rgba(100,21,255,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,35.655q2.087-1.356,4-2.793v2.48Q42.1,36.709,40.044,38Z",
    style: {
      fill: "rgba(100,21,255,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.66,16.57c-.16.64-.3,1.3-.43,1.97-.65-.22-1.28-.42-1.91-.61.13-.67.27-1.32.43-1.96C23.38,16.15,24.02,16.36,24.66,16.57Z",
    style: {
      fill: "rgba(100,21,255,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5,24.21a71.823,71.823,0,0,0-12.27-5.67c.13-.67.27-1.33.43-1.97a72.612,72.612,0,0,1,12.84,5.9c1.06.61,2.11,1.25,3.13,1.91.72.46,1.43.93,2.12,1.41A61.7,61.7,0,0,1,52.9,34.4l.67.74L52.1,36.49l-.67-.73a56.692,56.692,0,0,0-8.52-7.4c-.67-.5-1.36-.98-2.07-1.46Q38.74,25.505,36.5,24.21Z",
    style: {
      fill: "rgba(100,21,255,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.48,46.13l-.5.87c-1.04,1.8-3.43,2.73-6.89,2.73a27.086,27.086,0,0,1-4.86-.49,45.135,45.135,0,0,1-4.99-1.22c-.62-.18-1.25-.38-1.89-.59a72.692,72.692,0,0,1-12.85-5.9c-1.07-.62-2.12-1.26-3.13-1.91-.72-.46-1.43-.93-2.12-1.41C10.18,30.57,3.43,21.49,6.02,17c1.47-2.55,5.64-3.34,11.75-2.24a44.335,44.335,0,0,1,4.98,1.21c-.16.64-.3,1.29-.43,1.96a42.6,42.6,0,0,0-4.91-1.2c-4.98-.9-8.69-.42-9.66,1.27-1.54,2.68,3.02,10.24,13.34,17.66q.99.72,2.07,1.44,2.04,1.35,4.34,2.69a71.823,71.823,0,0,0,12.27,5.67c.64.21,1.28.42,1.9.61a42.252,42.252,0,0,0,4.92,1.2c4.98.9,8.69.42,9.66-1.27l.5-.87Z",
    style: {
      fill: "rgba(100,21,255,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.66,16.57c-.64-.21-1.28-.42-1.91-.6.26-1.14.56-2.23.88-3.27l.3-.95,1.91.59-.3.96C25.22,14.34,24.92,15.43,24.66,16.57Z",
    style: {
      fill: "rgba(100,21,255,1)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.784,
    cy: 46.722,
    r: 2,
    style: {
      fill: "rgba(100,21,255,1)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.085,
    cy: 40.284,
    r: 2,
    style: {
      fill: "rgba(100,21,255,1)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.132,
    cy: 7,
    r: 2,
    style: {
      fill: "rgba(100,21,255,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.529,41q-.165-1.369-.279-2.79c-.07-.84-.12-1.69-.16-2.55q-.016-.328-.03-.66h2q.04,1.068.1,2.1.09,1.29.21,2.52.07.7.153,1.38Z",
    style: {
      fill: "rgba(100,21,255,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,31.3q1.588-1.29,3-2.612L50.523,30c-1.382,1.3-2.9,2.594-4.523,3.851Z",
    style: {
      fill: "rgba(100,21,255,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,41.939c-2.007.99-4.021,1.874-6,2.636A54.681,54.681,0,0,1,19.473,46.9l-.976.22-.44-1.951.975-.22A53.688,53.688,0,0,0,27,42.428c1.982-.79,4-1.7,6-2.726Z",
    style: {
      fill: "rgba(100,21,255,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.452,17c-.326-1.441-.692-2.777-1.087-4h2.071c.383,1.255.73,2.592,1.037,4Z",
    style: {
      fill: "rgba(100,21,255,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.16,27c.109-1.7.273-3.373.489-5h2.014c-.221,1.622-.389,3.3-.5,5Z",
    style: {
      fill: "rgba(100,21,255,1)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScience);
export default __webpack_public_path__ + "static/media/science.5f462bbec7a68371185e4d863a15dafb.svg";
export { ForwardRef as ReactComponent };